import React from 'react';

function Interpretation() {
  return (
    <div>
      <h2>Interpretasi Skor</h2>
      <p>Hasil evaluasi dari kuisioner yang telah diisi.</p>
    </div>
  );
}

export default Interpretation;
